import { ChangeDetectionStrategy, Component, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SLOT_SHAPES, SlotShape } from '../../../core/models/loyalty-card.model';

/** Stamp Shape Picker: Círculo · Flor · Cuadrado · Sello · Hexágono (una forma para todos los espacios). */
@Component({
  selector: 'app-shape-picker',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ShapePickerComponent), multi: true }],
  template: `
    <div class="row" role="radiogroup" aria-label="Forma de los espacios">
      @for (s of shapes; track s.value) {
        <button type="button" class="opt" role="radio" [class.is-on]="value() === s.value" [attr.aria-checked]="value() === s.value" (click)="set(s.value)">
          <app-stamp-slot class="shape" [shape]="s.value" [color]="value() === s.value ? '#0A5C5A' : '#111316'" />
          <span>{{ s.label }}</span>
        </button>
      }
    </div>
  `,
  styles: [`
    .row{display:grid;grid-template-columns:repeat(5, minmax(0, 1fr));gap:4px}
    .opt{height:92px;border-radius:18px;border:1px solid var(--cr-border-subtle);background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;cursor:pointer;padding:6px 2px;min-width:0}
    .opt span{font:600 12px/16px var(--cr-font-body);color:var(--cr-text-secondary);white-space:nowrap}
    .opt.is-on{background:var(--cr-brand-teal-soft);border:2px solid var(--cr-brand-teal)}
    .opt.is-on span{color:var(--cr-brand-teal-strong)}
    .shape{width:40px;height:40px}
    @media (max-width:400px){ .row{grid-template-columns:repeat(3, minmax(0, 1fr));gap:8px} }
  `],
})
export class ShapePickerComponent implements ControlValueAccessor {
  readonly shapes = SLOT_SHAPES;
  readonly value = signal<SlotShape>('circle');
  private onChange: (v: SlotShape) => void = () => {};

  set(v: SlotShape): void { this.value.set(v); this.onChange(v); }
  writeValue(v: SlotShape): void { this.value.set(v || 'circle'); }
  registerOnChange(fn: (v: SlotShape) => void): void { this.onChange = fn; }
  registerOnTouched(): void {}
}
